import { Actions } from '../../../../utils/Action'
import { ActionTypes } from './types'
import { TDefRequest } from '../../../../types/actions'

/// ///////////////////////////////////////////////////////////////////////
const GetViewedItemsActivityActions = new Actions('GET_VIEWED_ITEM_ACTIVITY', ActionTypes)
const GetViewedItemsActivityWith0OffsetActions = new Actions('GET_VIEWED_ITEM_ACTIVITY_WITH_O_OFFSET', ActionTypes)

export interface TypeGetViewedItemsActivityR extends TDefRequest {
  idTender: number
  offset?: number
  limit?: number
  search?: string
  sortBy?: string
  sort?: string
}

export const GetViewedItemsActivity = {
  request: (payload: TypeGetViewedItemsActivityR) => GetViewedItemsActivityActions.request(payload),
  success: (payload: any) => GetViewedItemsActivityActions.success(payload),
  error: (payload: string) => GetViewedItemsActivityActions.error(payload),
}
export const GetViewedItemsActivityWith0Offset = {
  success: (payload: any) => GetViewedItemsActivityWith0OffsetActions.success(payload),
}

/// ///////////////////////////////////////////////////////////////////////
const GetViewedItemsActivityChildActions = new Actions('GET_VIEWED_ITEM_ACTIVITY_CHILD', ActionTypes)

export interface TypeGetViewedItemsActivityChildR extends TDefRequest {
  idItem: number
  idTender: number
}

export const GetViewedItemsActivityChild = {
  request: (payload: TypeGetViewedItemsActivityChildR) => GetViewedItemsActivityChildActions.request(payload),
  success: (payload: any) => GetViewedItemsActivityChildActions.success(payload),
  error: (payload: string) => GetViewedItemsActivityChildActions.error(payload),
}
